import React from 'react';
import './EmptyStateComponent.scss';
import { teslaCacheX } from '../../Upshow';
import ReactPlayer from 'react-player';
import Logger from '../../Logger';
import ScreenService from '../../services/ScreenService';
import { isXumoDevice } from '../../utils/isXumoDevice';
class EmptyStateComponent extends React.Component {

    
    constructor(props) {
        super(props);
        this.resources = ScreenService.isVertical 
        ? { url: 'https://cdn.upshow.tv/ui-assets/Everpass_No_Content_Vertical.mp4', poster: 'https://cdn.upshow.tv/ui-assets/Everpass_No_Content_Vertical.jpg' }
        : { url: 'https://cdn.upshow.tv/ui-assets/Everpass_No_Content_Horizontal.mp4', poster: 'https://cdn.upshow.tv/ui-assets/Everpass_No_Content_Horizontal.jpg' };

        this.url = teslaCacheX(this.resources.url);
        this.isXumo = isXumoDevice();
        this.xumoFallback = ScreenService.isVertical ? 'https://cdn.upshow.tv/ui-assets/Xumo_No_Content_Vertical.jpg' : 'https://cdn.upshow.tv/ui-assets/Xumo_No_Content_Horizontal.jpg';
    }

    render() {
        return this.isXumo ? ( 
            <div className="empty-state">
                <img src={this.xumoFallback} />
            </div> )
            : ( <div className="empty-state">
            <ReactPlayer
                width="100%" height="100%" volume={0} playing loop
                url={this.url}
                onError={(error) => Logger.warn('No Content state could not play loading media', error)}
                config={{
                    file: {
                        attributes: {
                            crossOrigin: 'anonymous',
                            poster: this.resources.poster
                        }
                    }
                }} />

        </div>);
    }
}

export default EmptyStateComponent;
